import React, { useState } from 'react'; 
import { Helmet } from 'react-helmet-async';
import { useNavigate, Link } from 'react-router-dom'; 
import { useAuth } from '../utils/AuthContext/AuthContext';
import MainCard from '../components/MainCard';
import config from '../utils/config'; 
import SEO from '../utils/SEO';
import { Turnstile } from '@marsidev/react-turnstile';

import GoogleLoginButton from '../components/GoogleLoginButton';
import GoogleSVG from '../assets/Google';


function Register() {
    const [userData, setUserData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
    }); 

    const { login } = useAuth(); 

    const navigate = useNavigate(); 
    const [error, setError] = useState('');
    const [turnstileToken, setTurnstileToken] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);
    // const [termsAndConditions, setTermsAndConditions] = useState('');  

    const handleChange = (e) => {
        const { name, value } = e.target; 
        setUserData(prev => ({ ...prev, [name]: value }));

        if (name === 'password') {
            validatePassword(value);
        }
    }; 

    // const handleTermsAndConditionsCheckbox = (event) => {
    //     setTermsAndConditions(event.target.checked ? 'yes' : 'no');
    // };

    const validatePassword = (password) => {
        const minLength = 6;
        if (password.length < minLength) {
            setError(`Password must be at least ${minLength} characters long.`);
        } else {
            setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (import.meta.env.VITE_ENABLE_TURNSTILE === 'true' && !turnstileToken) {
            setError('Please complete the Turnstile verification');
            return;
        }
        
        // Check the password length
        if (userData.password.length < 6) {
            setError('Password must be at least 6 characters long.');
            return;
        }

        setIsVerifying(true);
        try {
            const response = await fetch(`${config.apiBaseUrl}/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                    ...userData, 
                    turnstileToken: import.meta.env.VITE_ENABLE_TURNSTILE === 'true' ? turnstileToken : 'dev-mode'
                }),
                credentials: 'include'
            });
    
            if (response.ok) {
                const data = await response.json();
                // console.log('User registered:', data);
                login(data.token, data.user); // Save the token received from the server
                navigate('/'); // Redirect to home on success
            } else { 
                // Handle non-2xx HTTP responses
                const errorData = await response.json(); // only reading response body
                throw new Error(errorData.message || 'Registration Failed');
            }

        } catch (error) {
            setError(error.message); // Log the error message
        } finally {
            setIsVerifying(false);
        }
    };  

return (
    <>
        <SEO title="Register" description="Create your Shishito account to start building and managing real estate offers efficiently." />

        <div className="flex-1 flex justify-center items-center">
            <div className="h-[587px] w-full md:h-[750px] md:w-[750px] flex flex-col justify-start items-center">
                <MainCard maxHeight={475}>
                <h1 className="text-black text-[24px] md:text-[34px] w-full font-semibold font-['Inter']">Be Your Own Agent</h1>

                    <form onSubmit={handleSubmit} className='w-[300px] md:w-[450px] h-auto justify-between gap-5 items-start flex flex-col'>

                    <div className="relative flex flex-col mb-1 w-full border rounded-md border-slate-400 p-1 focus-within:ring-1 focus-within:ring-blue-800">
                        <span className="absolute -top-3 left-2 bg-white px-1 text-[12px] font-[Inter] text-slate-500">First Name</span>
                        <input 
                            type="text" 
                            name="firstName" 
                            value={userData.firstName} 
                            onChange={handleChange} 
                            // placeholder="First Name" 
                            className='w-full border-none outline-none pt-1'
                        />
                    </div>

                    {/* <div className="flex flex-col text-left justify-start items-start w-[350px] md:w-[750px]">
                            <div className="w-[350px] justify-between gap-2 items-start flex flex-col">
                                <span className='text-sm text-slate-600'>
                                    First Name
                                </span>
                            </div>
                        <input 
                            type="text" 
                            name="firstName" 
                            value={userData.firstName} 
                            onChange={handleChange} 
                            // placeholder="First Name" 
                            className='py-1 px-[1px] md:px-3 h-[39px] rounded-md border w-[300px] md:w-[450px] border-slate-300'
                        />
                    </div> */}

                    <div className="relative flex flex-col mb-1 w-full border rounded-md border-slate-400 p-1 focus-within:ring-1 focus-within:ring-blue-800">
                        <span className="absolute -top-3 left-2 bg-white px-1 text-[12px] font-[Inter] text-slate-500">Last Name</span>
                        <input 
                            type="text" 
                            name="lastName" 
                            value={userData.lastName} 
                            onChange={handleChange} 
                            // placeholder="Last Name" 
                            className='w-full border-none outline-none pt-1'
                        />
                    </div>

                    <div className="relative flex flex-col mb-1 w-full border rounded-md border-slate-400 p-1 focus-within:ring-1 focus-within:ring-blue-800">
                        <span className="absolute -top-3 left-2 bg-white px-1 text-[12px] font-[Inter] text-slate-500">Email</span>
                        <input 
                            type="email" 
                            name="email" 
                            value={userData.email} 
                            onChange={handleChange} 
                            // placeholder="Email" 
                            className='w-full border-none outline-none pt-1'
                        />
                    </div>

                    <div className="relative flex flex-col mb-1 w-full border rounded-md border-slate-400 p-1 focus-within:ring-1 focus-within:ring-blue-800">
                        <span className="absolute -top-3 left-2 bg-white px-1 text-[12px] font-[Inter] text-slate-500">Password</span>
                        <input 
                            type="password" 
                            name="password" 
                            value={userData.password} 
                            onChange={handleChange} 
                            // placeholder="Password" 
                            className='w-full border-none outline-none pt-1'
                        />
                    </div>

                    {import.meta.env.VITE_ENABLE_TURNSTILE === 'true' && (
                        <div className="w-full flex justify-center">
                            <Turnstile
                                siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY}
                                onSuccess={(token) => {
                                    console.log('Turnstile verification successful');
                                    setTurnstileToken(token);
                                }}
                                onError={(error) => {
                                    console.error('Turnstile error:', error);
                                    setError('Turnstile verification failed');
                                }}
                                onExpire={() => {
                                    console.log('Turnstile expired');
                                    setTurnstileToken('');
                                }}
                                options={{
                                    refreshExpired: 'manual',
                                    appearance: 'always',
                                    language: 'auto',
                                    size: 'normal',
                                    theme: 'light',
                                    autoResetOnTimeout: false
                                }}
                            />
                        </div>
                    )}

                        <div className="w-full h-[35px] md:h-[41px] mt-2 justify-center inline-flex">
                            <button 
                                className={`w-[100px] md:w-[150px] justify-center items-center text-white text-sm md:text-lg font-normal font-['Inter'] p-[1px] md:p-1.5 rounded-md border flex ${
                                userData.firstName && userData.lastName && userData.email && userData.password ? 'bg-shi-green border-shi-green hover:bg-green-950' : 'bg-gray-400 border-gray-400 cursor-not-allowed'
                                }`}
                                type="submit"
                                // disabled={!(termsAndConditions === 'yes' && userData.firstName && userData.lastName && userData.email && userData.password)}>
                                disabled={!(userData.firstName && userData.lastName && userData.email && userData.password) || isVerifying}>
                                {isVerifying ? 'Verifying...' : 'Register'}
                            </button>
                        </div>
                        {error && <p className='text-red-700 text-semibold'>{error}</p>}
                    </form>

                    <div className="flex items-center justify-center w-full">
                            <div className="border-t border-gray-300 flex-grow"></div>
                            <span className="px-4 text-gray-500">or</span>
                            <div className="border-t border-gray-300 flex-grow"></div>
                        </div>

                    {/* <GoogleLoginButton disabled={!termsAndConditions}/> */}
                    <GoogleLoginButton />

                    <div className="w-[330px] md:w-[650px] text-[15px] md:text-[16px] justify-center inline-flex">
                        {/* <input 
                            type="checkbox" 
                            onChange={handleTermsAndConditionsCheckbox} 
                            id="termsAndConditions"
                            checked={termsAndConditions === 'yes'}
                        /> */}
                        <span className="pl-3 font-semibold text-[13px] md:text-[16px]">
                            Buy Creating an Account You Agree to <a href="/TermsofUse" className="text-blue-500 hover:text-blue-700">Shishito's Terms of Use</a>
                        </span>
                    </div>

                    <Link 
                            to="/login"
                            className="w-[300px] md:w-[350px] justify-center text-center text-shi-green bg-white border-white text-sm md:text-[14px] font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-start flex"
                            >Already Have an Account? Sign In
                        </Link>
                </MainCard>
            </div>
        </div>
    </>
    );
}

export default Register;